export interface IEditInfo {
  editRoute?: string;
  editable: boolean;
  removable?: boolean;
  editContent?: string;
  noRoutingEdit?: boolean;
}

export interface IReceipt extends IEditInfo {
  header: string;
  description?: string | null;
  rows: ReceiptRow[];
  sectionEvidenceID?: string;
}

export interface TooltipReceipt extends IReceipt {
  toolTip: string;
}

export interface ReceiptRowBanner {
  title: string;
  text: string;
}

export interface ReceiptRow {
  label: string;
  values: string[];
  evidenceID: string;
  modal?: string;
  hideBorder?: boolean;
  customLineHeight?: boolean;
  hideRow?: boolean;
  isLabelBold?: boolean;
  additionalText?: string;
  isLabelBoldGrey?: boolean;
  banner?: ReceiptRowBanner;
}

export interface CO6ReceiptRows {
  [key: string]: CO6ReceiptRow | string;
}

export interface CO6ReceiptRow {
  label: string;
  values: string[];
}
export interface IReceiptDTO {
  owner: IReceipt;
  documents: IReceipt;
  beneByRelationship: IReceipt;
  from: IReceipt;
  gift: IReceipt;
  to: IReceipt;
  profile: IReceipt;
  employment: IReceipt;
  financial: IReceipt;
  defaultBeneficiary: IReceipt;
  additionalTaxLots: TooltipReceipt;
  estate?: IReceipt;
  funding?: IReceipt;
  trustInfo?: IReceipt;
  addedTrustee?: IReceipt;
  removedTrustee?: IReceipt;
}

export interface CO6ReceiptDTO {
  owner: IReceipt;
  documents: IReceipt;
  beneByRelationship: IReceipt;
  from: IReceipt;
  gift: IReceipt;
  to: IReceipt;
  profile: IReceipt;
  employment: IReceipt;
  financial: IReceipt;
  defaultBeneficiary: IReceipt;
  additionalTaxLots: TooltipReceipt;
  estate?: IReceipt;
  funding?: IReceipt;
  addedTrustee?: IReceipt;
  removedTrustee?: IReceipt;
}

export interface InternalTransferReceiptDTO {
  from: IReceipt;
  to: IReceipt;
  profile: IReceipt;
  employment: IReceipt;
  financial: IReceipt;
}

export enum ExcludedReceiptKey {
  DEFAULTBENEFICIARY = 'defaultBeneficiary',
}
